module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"discount":"Discount {discount}% off"},"zh-tw":{"discount":"優惠折扣 {discount}%"}}')
  delete Component.options._Ctor
}
